<fieldset class="bordas" [style]="'height: 135px; width: auto'">
    <div>
        <div fxLayout="column" fxFlex="90%">
            <div fxLayout="row" fxLayoutGap="20px">
                <div ngModelGroup="comboBeneficiario_{{idRandomico}}" fxFlex="70">
                    <combo-beneficiario [showDisplayId]="false"
                                        [obrigatorio]="true"
                                        [selecionado]="frequenciaAcao.aluno"
                                        (valorChange)="onValorChangeAluno($event)">
                    </combo-beneficiario>
                </div>

                <mat-form-field fxFlex="30">
                    <mat-label>Situação</mat-label>
                    <mat-select [(ngModel)]="frequenciaAcao.situacao" name="situacao_{{idRandomico}}" required>
                        <mat-option *ngFor="let m of situacaoFrequencia.situacao" [value]="m.flag">
                            {{ m.tipo }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutGap="100px">
                <mat-form-field fxFlex="100" fxLayoutGap="20px" fxFlexOffset="20px">
                    <input #justificativa matInput maxlength="200" name="justificativa_{{idRandomico}}"
                           placeholder="Justificativa" [(ngModel)]="frequenciaAcao.justificativa"
                           [required]="frequenciaAcao.situacao == 'N'">
                    <mat-hint align="end">{{ justificativa.value.length }} / 200</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div fxLayout="column" fxFlex="10%" fxLayoutAlign="center center">
            <button mat-icon-button *ngIf="perfilAcesso.deleta" (click)="deletar()" style="padding: 0px;">
                <mat-icon>delete_forever</mat-icon>
            </button>
        </div>
    </div>
</fieldset>